/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState, useRef } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation, useHistory } from "react-router-dom";
import logo from "@/img/logo.png"
import { IsPC } from "../../../utils/index";
import { AutoCenter, Button, List, Mask, Toast, Tabs, Popup, Ellipsis } from "antd-mobile"
import { post, get } from "../../../component/fetch"
import store from "src/reducers"
import { useThrottleFn } from 'ahooks'
import moment from "moment";
import { UnorderedListOutline, PlayOutline, ContentOutline, CloseCircleFill, RightOutline,FileOutline, SystemQRcodeOutline } from "antd-mobile-icons"
import { isInHarmonyOS } from "src/utils/web-call-app";
// let playInfo = localStorage.getItem('playInfo')
// let siteid = playInfo ? JSON.parse(playInfo).liveAccount : '';
const { BASE_URL, PUBLIC_URL } = process.env
export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};
let newWindow = window as any

const Index = () => {
    const history = useHistory();
    const query = useQuery()
    const contentRef = useRef(null);
    const subjectId = query.get('subjectId')
    const columnId = query.get('columnId')
    const [columnList, setColumnList] = useState([])
    const [currentVideo, setCurrentVideo] = useState({})
    const [recommendList, setRecommendList] = useState([])
    // const [codeModal, setCodeModel] = useState(false)
    const [qrCodeModal, setQrCodeModal] = useState(false)
    // const columnInfo: any = store.getState().InitPageData
    const [activeKey, setActiveKey] = useState('1')
    const tabRef = useRef(null)
    const [columnInfo, setColumnInfo] = useState({})
    const [qrcodeModal, setQrcodeModal] = useState(false)
    const userInfo: any = store.getState().userInfo
    window.on_CCH5player_ready = ()=>{
        if(document.getElementsByClassName('ccH5FullsBtn')&&isInHarmonyOS()){
            let el = document.getElementsByClassName("ccH5FullsBtn")[0]
            el.style.display = "none"
        }
      }
    newWindow.isLogin = () => {
        Toast.show({
            content: "请重新登录"
        })
        history.push(`/login?columnId=${columnId}&subjectId=${subjectId}`)
    };
    newWindow.isNeedAddBaseInfo = () => {
        //    setSignView(true) 
        Toast.show({
            content: "请填写报名信息"
        })
        history.push(`/signup?columnId=${columnId}&subjectId=${subjectId}`)
    }
    const { run: handleScroll } = useThrottleFn(
        () => {
            let currentKey = tabItems[0].key
            for (const item of tabItems) {
                // console.log(item)
                const element = document.getElementById(`anchor-${item.key}`)
                if (!element) continue
                if (contentRef.current.scrollTop >= element.offsetTop + 10 || contentRef.current.scrollTop >= element.offsetTop - 10) {
                    currentKey = item.key
                } else {
                    break
                }
                setActiveKey(currentKey)
            }
        },
        {
            leading: true,
            trailing: true,
            wait: 100,
        }
    )

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return () => {
            newWindow.isLogin = null
            newWindow.isNeedAddBaseInfo = null
        }
    }, []);

    const initVideo = (current: any) => {
        if (window.createCCH5Player) {
            window.ccPlayerStatus = window.createCCH5Player({
                vid: current?.videoUrl,
                siteid: current?.ccUserId,
                autoStart: true,
                width: IsPC ? "100%" : "100vw",
                height: "280px",
                banDrag: "false",
                playtype: 1,
                rate_allow_change: false,
                watchAt: current?.videoWatchAt,
                parentNode: document.getElementById("livePlayer"),
            });
            
        
        }

    };
    const changeCurrentVideo = (current: any) => {
        setCurrentVideo(current)
    }
    //设置视频缓存信息
    const setResultInfo = (res: any) => {
        let data = { ...res, runStatus: columnInfo.runStatus }
        data.type && delete data.type
        setVideoInfo(data);
    };
    const setVideoInfo = (res: any) => {
        store.dispatch({
            type: "SET_VIDEO_STATUS",
            ...res
        })
        initVideo(res)
    }
    const getVideoInfo = async () => {
        await post('/shop/front/ge/column/getSubjectWatchSectionInfo', {
            subjectId,
            courseId: currentVideo.courseId,
            sectionId: currentVideo.id
        }, false).then(res => {
            setResultInfo({ ...res.data.currentSection, columnId, subjectId, sectionId: res.data.currentSection.id, runStatus: columnInfo.runStatus })
        })
    }
    const getInitData = async () => {
        const { data } = await get('/shop/front/ge/column/subject/getDetail?subjectId=' + subjectId, {}, false)
        setColumnInfo(data)
        if(data.type===1){
            const data2 = await post('/shop/front/ge/column/subject/content/getList', {
                subjectId,
            }, false)  
            setRecommendList(data2.data.list)
            const res = await post('/shop/front/ge/column/getSubjectCourseSectionList', { subjectId }, false)
            setColumnList(res.data.list)
            setCurrentVideo(res.data.list[0])
        }
    }
    useEffect(() => {
        contentRef.current.addEventListener('scroll', handleScroll)
    }, [])
    useEffect(() => {
        getInitData()
    }, [])
    useEffect(() => {
        if (currentVideo.id) {
            if (userInfo.userId) {
                getVideoInfo()
            } else {
                setResultInfo({ ...currentVideo, columnId, subjectId, sectionId: currentVideo.id, runStatus: columnInfo.runStatus })
            }
        }
    }, [currentVideo])
    const tabItems = columnInfo.type === 1 ? [
        { key: '1', title: '介绍', },
        { key: '2', title: '目录', },
        { key: '3', title: '推荐', },
    ] : [
        { key: '1', title: '介绍', },
    ]
    const getLinkProject = () => {
        post('/shop/front/activity/project/watch/info/'+columnInfo.projectId,{},false).then(res=>{
            if(res.code === 0){
             window.location.href = res.data.mobileWatchUrl
            }
         }).catch(res=>{
             if(res.code === 101){
                Toast.show({
                    content: "请重新登录"
                })
                history.push(`/login?columnId=${columnId}&subjectId=${subjectId}`)
             }
         })
    }
    return (
        <div className={Style.wrapper}>
            {columnInfo.type===1 ? <div className="disableFullsBtns" id="livePlayer" ></div> : <img src={columnInfo.logoUrl} alt=""/>}
            <div className={Style.content} ref={contentRef}>
                {/* <DemoBlock title='作为页面滚动的导航' padding='0'> */}
                <div className={`${Style.tabsContainer}`} ref={tabRef}>
                    <Tabs
                        activeKey={activeKey}
                        onChange={(key: any) => {
                            document.getElementById(`anchor-${key}`)?.scrollIntoView()
                            console.log(contentRef.current.scrollTop, tabRef.current.offsetHeight)
                            contentRef.current.scrollTo({
                                top: contentRef.current.scrollTop - tabRef.current.offsetHeight,
                            })
                        }}
                    >
                        {tabItems.map(item => (
                            <Tabs.Tab title={item.title} key={item.key} />
                        ))}
                    </Tabs>
                </div>
                <div className={`${Style.content} plr40 pos-r`} id="mobile-content" >
                    <div id={`anchor-${1}`}>
                        <h2 >{columnInfo.titleName}</h2>
                        <p>开放时间：{moment(columnInfo.openTimeBegin).format('YYYY-MM-DD')} - {moment(columnInfo.openTimeEnd).format('YYYY-MM-DD')}</p>
                      {!isInHarmonyOS&&<p className="c-bg-fff plr20 ptb20 radios12 justify-between ac" onClick={() => { setQrCodeModal(true) }}><span className="flex ac"><SystemQRcodeOutline className="fs24 mr40" /> 加入专属交流社群</span> <span className="fr"><RightOutline /></span></p>}
                      {columnInfo.type === 2 && <p className="c-bg-fff plr20 ptb20 radios12 flex ac fs18 justify-between" onClick={() => { 
                            getLinkProject()
                        }}><span className="flex ac "><FileOutline className="mr40 fs24" /> 立即学习</span> <span className="fr"><RightOutline /></span></p>}
                        <h3 className="mt80">课程介绍</h3>
                        <div className="c-bg-fff plr20 ptb20 l-h-20 radios12">
                            <div dangerouslySetInnerHTML={{ __html: columnInfo.content }}></div>
                            {/* <Ellipsis
                                direction='end'
                                rows={3}
                                content={'本期“毕教大讲堂-管理学苑”（第9期）特邀请复旦大学附属华山医院教育处继教科黄虑科长，为大家讲授《保障住院医师、专科医师培训质量-师资队伍建设与管理》课程，旨在帮助各住培专业基地管理者更好的理解住培师资队伍的建设要求，掌握住培师资管理方法和工具'}
                                expandText='查看全部'
                                collapseText='收起'
                            /> */}
                        </div>
                    </div>
                    {columnInfo.type===1 && <div id={`anchor-${2}`}>
                        <h3 className="mt80">课程目录</h3>
                        <List classNamge='c-bg-fff radios12'>
                            {columnList.map((item: any, index: number) => {
                                return <List.Item key={index} style={{color:currentVideo.id===item.id ? 'blue' : ''}} onClick={() => {
                                    changeCurrentVideo(item)
                                }} prefix={<PlayOutline />} arrow={false} extra={item.durationText}> <Ellipsis direction='end' content={item.name} /></List.Item>
                            })}

                        </List>
                    </div>}
                    {columnInfo.type===1&&<div id={`anchor-${3}`}>
                        <h3 className="mt80">内容推荐</h3>
                        <List>
                            {recommendList.map((item: any, index: number) => {
                                return <List.Item key={index} arrow={false} onClick={() => {
                                    item.titleUrl ? window.location.href = item.titleUrl : history.push(`/recommend/${item.id}?subjectId=${subjectId}`)
                                }}><div className="flex ac" ><img className={`${Style.logoImg}`} src={item.logoUrl} alt="" /><div className="fs12 plr80">{item.titleName}</div></div></List.Item>
                            })}

                        </List>
                    </div>}
                </div>
                {/* </DemoBlock> */}
            </div>
            {/* <div className={`plr40 ptb40`}>
                <div style={{marginTop:"10px",fontSize:"20px",fontWeight:"bold"}}>{columnInfo.titleName}
                </div>
                <div style={{marginTop:"10px"}}>主办单位：{columnInfo.hostUnit}</div>
            </div> */}
            {/* <AutoCenter className={`tc fw fw-b ${Style.title}`}>{columnInfo.titleName}</AutoCenter> */}
            {/* {columnInfo.qrCodeUrl&& <div className="plr40">
                <Button className={Style.myBtns}  onClick={() => {
                    setQrCodeModal(true)
                }}>获取课程资料</Button>
            </div>} */}
            {/* <div className={`${Style.content}`}>
                <div className="fs20">
                    <UnorderedListOutline /> 目录
                </div>
                <List>
                    {columnList.map((item: any, index: number) => {
                        return <List.Item key={index} onClick={() => {
                            changeCurrentVideo(item)
                        }} style={{ color: item.id === currentVideo.id ? '#7dbcff' : '' }} prefix={<PlayOutline />}>{item.name}</List.Item>
                    })}
                </List>
                {recommendList.length>0 && <div className="fs20 mt160">
                    <div>
                        <ContentOutline /> 推荐内容
                    </div>
                    <List>
                    {recommendList.map((item: any, index: number) => {
                        return <List.Item  key={index} onClick={() => {
                            item.titleUrl ? window.location.href = item.titleUrl : history.push(`/recommend/${item.id}?subjectId=${subjectId}`)
                        }}><div className="ptb40" ><img className={`${Style.logoImg}`} src={item.logoUrl} alt="" /></div><div className="fs12">{item.titleName}</div></List.Item>
                    })}
                </List>
                </div>}
              
                <Mask visible={qrCodeModal} style={{ zIndex: "999999" }} onMaskClick={() => setQrCodeModal(false)}>
                    <div className="qrCode">
                        <img src={columnInfo.qrCodeUrl} alt="" />
                        <p className="c-fff fs24 tc">长按扫码</p>
                        <p className="c-fff fs32 tc" onClick={() => setQrCodeModal(false)}><CloseCircleFill /></p>
                    </div>
                </Mask>
            </div> */}
            <Popup
                visible={qrCodeModal}
                onMaskClick={() => {
                    setQrCodeModal(false)
                }}
                bodyStyle={{
                    borderTopLeftRadius: '8px',
                    borderTopRightRadius: '8px',
                    minHeight: '40vh',
                }}
            >
                <div className={Style.qrCodeModal}>
                    <img className={Style.qrCode} src={columnInfo.qrCodeUrl} alt=""></img>
                    <p style={{ textAlign: "center", marginTop: "20px" }} dangerouslySetInnerHTML={{ __html: columnInfo.qrCodeContent }}></p>
                </div>
            </Popup>
        </div>
    );
};

export default Index;
